// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"85062b15","777":"4bb9bff6"}[chunkId] + ".chunk.js";
};